import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronRight, Home } from 'lucide-react';
import { useSEO } from '../contexts/SEOContext';

/**
 * Breadcrumbs - visible crumbs + BreadcrumbList JSON-LD.
 *
 * Props:
 *  - items: [{ name: string, href?: string }]  // last item is typically current page without href
 */
export default function Breadcrumbs({ items = [] }) {
  const { seo } = useSEO();
  const baseUrl = (seo && seo.canonical_base_url) || (typeof window !== 'undefined' ? window.location.origin : '');

  const list = [{ name: 'Ana Sayfa', href: '/' }, ...items];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: list.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      ...(it.href ? { item: `${baseUrl}${it.href}` } : {}),
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="text-sm text-slate-500 mb-4" data-testid="breadcrumbs">
        <ol className="flex items-center flex-wrap gap-1">
          {list.map((it, i) => {
            const last = i === list.length - 1;
            return (
              <li key={i} className="flex items-center">
                {i === 0 && <Home className="w-3.5 h-3.5 mr-1 text-slate-400" />}
                {last || !it.href ? (
                  <span className={`${last ? 'text-slate-700 font-medium' : ''}`}>{it.name}</span>
                ) : (
                  <Link to={it.href} className="hover:text-emerald-600 transition-colors">{it.name}</Link>
                )}
                {!last && <ChevronRight className="w-3.5 h-3.5 mx-1 text-slate-300" />}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
